import { ColorPicker as AlchemyColorPicker } from '@m/alchemy-ui/ColorPicker';
import { Button } from '@m/alchemy-ui/Button';
import { Card } from '@m/alchemy-ui/Card';
import { CardBody } from '@m/alchemy-ui/CardBody';
import { CardFooter } from '@m/alchemy-ui/CardFooter';
import { CardHeader } from '@m/alchemy-ui/CardHeader';
import { CardImageCap } from '@m/alchemy-ui/CardImageCap';
import { EditIcon } from '@m/alchemy-ui/icons/EditIcon';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { type ColorPickerProps } from '../../features';

export const ColorPicker = ({ currentColor, name, onChange }: ColorPickerProps) => {
  const intl = useIntl();

  const defaultColor = currentColor || 'FFFFFF';
  const [selectedColor, setSelectedColor] = useState(`#${defaultColor}`);
  const [selectedColorObject, setSelectedColorObject] = useState({
    color: selectedColor,
    hex: selectedColor
  });
  return (
    <>
      <Card>
        <CardImageCap>
          <div
            style={{
              background: selectedColorObject.color,
              height: '80px',
              minWidth: '150px',
              width: '100%'
            }}
          />
        </CardImageCap>
        <CardHeader title={name} />
        <CardBody>
          <p>
            {`${intl.formatMessage({ id: 'color', defaultMessage: 'Color' })}:`} {selectedColorObject.hex}
          </p>
        </CardBody>
        <CardFooter>
          <AlchemyColorPicker
            hasColorField
            hasConfirmButtons
            selectedColor={selectedColor}
            onChange={(newColorObject) => {
              if (newColorObject.isValidCssColor) {
                setSelectedColor(newColorObject.color);
                setSelectedColorObject(newColorObject);

                if (onChange) {
                  onChange(newColorObject.hex);
                }
              }
            }}
            trigger={() => (
              <Button tabIndex={0} icon={<EditIcon aria-hidden />}>
                {intl.formatMessage({ id: 'edit', defaultMessage: 'Edit' })}
              </Button>
            )}
          />
        </CardFooter>
      </Card>
    </>
  );
};
